import { adminApi } from '@/includes/contentManagementApi';

export default class NetworkTeammanagement {
  static updateTeam(teamPayload, config) {
    const id = teamPayload?.team?._id;
    return adminApi.patch(`teams/${id}`, teamPayload, config);
  }

  static createTeam(teamPayload, config) {
    return adminApi.post('teams', teamPayload, config);
  }

  static deleteTeam(teamPayload, config) {
    return adminApi.delete(`teams/${teamPayload.teamID}`, config);
  }
}
